import React from 'react';
import { BarChart3, FileCheck2, MessageSquareText } from 'lucide-react';

const principles = [
  {
    icon: FileCheck2,
    title: 'Built around uploaded data',
    body: 'GabMic starts with your CSV or Excel file, detects columns, and shows what can be measured from those rows.',
  },
  {
    icon: BarChart3,
    title: 'Analytics that adapt',
    body: 'Sales, finance, marketing, service, and operational files produce different charts and summaries based on their columns.',
  },
  {
    icon: MessageSquareText,
    title: 'Answers with boundaries',
    body: 'Ask GabMic can explain totals, changes, patterns, and comparisons without inventing results that are not in the file.',
  },
];

const AboutSection: React.FC = () => {
  return (
    <section id="about" style={{ padding: '8rem 0', borderTop: '1px solid var(--border-color)' }}>
      <div className="container">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '3rem', alignItems: 'start' }}>
          <div>
            <span className="mono-label">About GabMic</span>
            <h2>AI analytics without the enterprise maze.</h2>
            <p>
              GabMic is a focused business-data analytics platform for people who need useful answers quickly. It turns structured files into metrics, filters, charts, tables, summaries, and AI explanations.
            </p>
          </div>

          <div style={{ display: 'grid', gap: '1rem' }}>
            {principles.map((item) => {
              const Icon = item.icon;

              return (
                <div key={item.title} className="matte-surface" style={{ padding: '1.2rem', display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                  <span className="icon-tile" style={{ flex: '0 0 auto' }}>
                    <Icon size={20} />
                  </span>
                  <div>
                    <h3 style={{ fontSize: '1.05rem', marginBottom: '0.35rem' }}>{item.title}</h3>
                    <p style={{ margin: 0, fontSize: '0.95rem' }}>{item.body}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
